/**
 * @generated SignedSource<<128de20d9f6f8e54bc809fb476572379>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_viewer" | "PdpSharedSocialShareEmail_viewer">;
  readonly " $fragmentType": "PdpRespIconBubbles_viewer";
};
export type PdpRespIconBubbles_viewer$key = {
  readonly " $data"?: PdpRespIconBubbles_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "544399f99db1a8e3a62f6b92041ad628";

export default node;
